import { Actions, ActionTypes } from './actions';
import { initialState, MyInformationState } from './state';

export function myInformationReducer(state = initialState, action: Actions): MyInformationState {
  switch (action.type) {
    case ActionTypes.GET_ROOT_FOLDER_REQUEST:
      return {
        ...state,
      };
    case ActionTypes.GET_ROOT_FOLDER_SUCCESS:
      return {
        ...state,
        rootFolders: action.payload,
      };

    default: {
      return state;
    }
  }
}
